import script from "./PublicationAboutTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationAboutTab.vue?vue&type=script&setup=true&lang=js"

import "./PublicationAboutTab.vue?vue&type=style&index=0&id=27fcf0aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fcf0aa"]])

export default __exports__